export function removerCaracterEspecial(texto: string) {
  if (!texto) return '';

  // Remove caracteres especiais, exceto | / , -
  let textoFormatado = texto.replace(/[`~!@#$°%^&*()_+=?;'"<>{}[\]\\]/gi, '');

  // Substitui caracteres acentuados por seus equivalentes sem acento
  textoFormatado = textoFormatado.replace(/[áàãâä]/g, 'a');
  textoFormatado = textoFormatado.replace(/[ÁÀÃÂÄ]/g, 'A');
  textoFormatado = textoFormatado.replace(/[éèêë]/g, 'e');
  textoFormatado = textoFormatado.replace(/[ÉÈÊË]/g, 'E');
  textoFormatado = textoFormatado.replace(/[íìîï]/g, 'i');
  textoFormatado = textoFormatado.replace(/[ÍÌÎÏ]/g, 'I');
  textoFormatado = textoFormatado.replace(/[óòõôö]/g, 'o');
  textoFormatado = textoFormatado.replace(/[ÓÒÔÕÖ]/g, 'O');
  textoFormatado = textoFormatado.replace(/[úùûü]/g, 'u');
  textoFormatado = textoFormatado.replace(/[ÚÙÛÜ]/g, 'U');
  textoFormatado = textoFormatado.replace(/ç/g, 'c');
  textoFormatado = textoFormatado.replace(/Ç/g, 'C');

  // Substitui quaisquer caracteres não alfanuméricos, exceto | / , -
  textoFormatado = textoFormatado.replace(/[^a-zA-Z0-9|/,-]/g, ' ');

  return textoFormatado;
}